import { gateway } from "../../../gateway";

export const sendPostMessage = async (messageData) => {
  try {
    const formData = new FormData();

    formData.append("name", messageData.name);
    formData.append("receiver", JSON.stringify(messageData.receiver));

    if (messageData.plainText) {
      formData.append("plainText", messageData.plainText);
    }

    if (messageData.file) {
      formData.append("file", messageData.file);
    }

    const res = await gateway.post("/messages", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return res.data;
  } catch (error) {
    console.error("Error in postMessage:", error?.response?.data ?? error);
    throw error;
  }
};
